(function () {
  'use strict';
  /**
    * Common Services Modules Version - 0.5.x
    *
    * __DataTable     : 0.5.2 - 23 APR 2015
    *
    *-------------------------------------------------------- */

  /**
   * DataTable Utilities & Services.
   *-------------------------------------------------------- */

  //Datatables Defaults
  $.extend($.fn.dataTable.defaults, {
    "serverSide": true,
    "iCookieDuration": 60,
    "paging": true,
    "processing": true,
    "responsive": true,
    "destroy": true,
    "retrieve": true,
    "lengthChange": false,
    "language": {
      "emptyTable": "There are no records to display."
    },
    searching: false,
    "ajax": {
      // any additional data to send
      "data": function (additionalData) {
        additionalData.page = (additionalData.start / additionalData.length) + 1;
      }/*,
              "dataSrc": function ( responseJson ) {
                 console.log(responseJson);
                if( responseJson.userAuth && (!responseJson.userAuth.isAuthenticated)) {

                  // set user auth information
                  AuthService.setUserAuthenticated(responseJson.userAuth);
                  
                  $state.go('login');

                  return false;
                }

                return responseJson;
              }*/
    }
  });


  /**
     * DataTables Services
     *
     * @inject $rootScope
     * @inject $compile
     * @inject __Utils     
     *     
     *-------------------------------------------------------- */
  angular.module("lw.data.datatable", []).
    service("__DataTable", [
      "$rootScope", "$compile", "__Utils", '__appCommonService', __DataTable
    ]);

  function __DataTable($rootScope, $compile, __Utils, __appCommonService) {

    /**
     * DataTable Custom Configuration generation based on provided data
     *
     * @param object {options} - Object  
     *                         url          (required)
     *                         scope        (required)
     *                         columnsData  (required)
     *                         dtOptions    (optional)
     *     
     * @return array
     *-------------------------------------------------------- */

    this.dtConfig = function (options) {

      var dtOptionsCollection = {
        "ajax": {
          "url": options.url
        },
        "columns": [],
        "createdRow": function (nRow) {
          $compile(nRow)(options.scope);
        }
      };

      if (options.dtOptions) {
        $.extend(dtOptionsCollection, options.dtOptions);
      }

      if (__appCommonService && __appCommonService.hasOwnProperty('appDataTableAjaxConfig')) {

        var appDataTableAjaxConfig = __appCommonService.appDataTableAjaxConfig();

        if (appDataTableAjaxConfig) {
          $.extend(dtOptionsCollection.ajax, appDataTableAjaxConfig);
        }

      }

      dtOptionsCollection.columns = _.map(options.columnsData, function (dtColumnData) {
        return {
          "data": dtColumnData.name ? dtColumnData.name : null,
          "orderable": dtColumnData.orderable ? true : false,
          "render": function (subject, data, obj, settings) {

            if (!dtColumnData.name) {
              obj = subject;
            } else {
              obj.dtSubject = dtColumnData.name;
            }
            // if template given
            if (dtColumnData.template) {
              // compile data using underscore template
              return __Utils.template(
                dtColumnData.template, obj
              );
            } else {
              return obj[dtColumnData.name];
            }

          }

        };
      });

      return dtOptionsCollection;
    };


    // a container to store temp datatables references while using tabs
    this.tabDtReferences = {};

    /**
    * DataTable intialization for Tab based tables
    *
    * @param string {tableID} - html table selector
    * @param object {options} - additional configurations items may need (eg. options.config, options.selectedTab)
    *     
    * @return DataTable
    *-------------------------------------------------------- */

    this.tabDataTable = function (tableID, options) {

      var dTable = $(tableID + options.selectedTab).DataTable(this.dtConfig(options.config)),
        tabPropertyTitle = "tab_" + options.selectedTab;

      // Check if user logged in unless redirect to the login window
      // Note:  be sure you have injected AuthService & $state
      /*dTable.on( 'xhr', function () {
        var responseJson = dTable.ajax.json();
        if( responseJson && responseJson.userAuth && (!responseJson.userAuth.isAuthenticated)) {
          AuthService.setUserAuthenticated(responseJson.userAuth);
          $state.go('login');
        }
      });*/

      if ((options.selectedTab !== undefined)) {
        if (this.tabDtReferences.hasOwnProperty(tabPropertyTitle)) {
          dTable.ajax.reload();
        } else {
          this.tabDtReferences[tabPropertyTitle] = options.selectedTab;
        }

      }

      return dTable;
    };

    this.dtSelfUpdate = function () {
      this.dataTableInstance.ajax.reload(null, false);
    };

    this.dataTable = function (tableID, options) {

      var dTable = $(tableID).DataTable(this.dtConfig(options.config));

      // Check if user logged in unless redirect to the login window
      // Note:  be sure you have injected AuthService & $state
      /*dTable.on( 'xhr', function () {
        var responseJson = dTable.ajax.json();
        if( responseJson && responseJson.userAuth && (!responseJson.userAuth.isAuthenticated)) {
          AuthService.setUserAuthenticated(responseJson.userAuth);
          $state.go('login');
        }
      });*/

      dTable.ajax.reload();
      this.dataTableInstance = dTable;
      return dTable;
    };

  };

})();
